import { ForwardedRef, forwardRef, ReactNode } from "react"
import { ColorPicker } from "./ColorPicker"
import { useCurrentPage } from "../hooks/useCurrentPage"
import { PopoverButton } from "./PopoverButton"
import { Color, Expr } from "../../shared/Expr"

type Props<T extends HTMLElement> = {
  children: (
    clickHandler: (event: React.MouseEvent<T>) => void,
    ref: ForwardedRef<HTMLButtonElement>,
    color: Expr<Color> | Expr<Color>[],
  ) => ReactNode
  color: Expr<Color> | Expr<Color>[]
  onChange: (color: Expr<Color>) => void
  noParams?: boolean
}

export const ColorPickerButton = forwardRef<
  HTMLButtonElement,
  Props<HTMLButtonElement>
>(function ColorPickerButton({ color, onChange, children, noParams }, ref) {
  const page = useCurrentPage()

  const colorParameters = Object.entries(page.meta.parameters ?? {}).filter(
    ([_, p]) => p.type === "color",
  )

  const parameterValues = page.meta.parameterValues

  return (
    <PopoverButton
      ref={ref}
      renderButton={(clickHandler, ref) => children(clickHandler, ref, color)}
    >
      {() => (
        <>
          <ColorPicker
            color={
              !Array.isArray(color) && color.type === "lit"
                ? color.value
                : undefined
            }
            onChange={(color) => onChange(Expr.lit(color))}
          />
          <div
            style={{
              display: "flex",
              gap: 4,
              flexDirection: "column",
              padding: 4,
            }}
          >
            {!noParams &&
              colorParameters.map(([id, p]) => (
                <div key={id}>
                  <button
                    style={{
                      display: "flex",
                      padding: "4px 8px",
                      gap: 4,
                      borderRadius: 99,
                      border: "1px solid #ddd",
                      alignItems: "center",
                    }}
                    onClick={() => onChange(Expr.ref(id))}
                  >
                    <span
                      style={{
                        opacity:
                          !Array.isArray(color) &&
                          color.type === "ref" &&
                          color.id === id
                            ? 1
                            : 0,
                      }}
                    >
                      ✔
                    </span>
                    <div
                      style={{
                        borderRadius: 2,
                        width: 30,
                        height: 18,
                        background: Expr.evaluate(parameterValues[id], {}),
                      }}
                    ></div>
                    {p.name}
                  </button>
                </div>
              ))}
          </div>
        </>
      )}
    </PopoverButton>
  )
})
